"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolLoader = ToolLoader;
exports.toolAllowList = void 0;
Object.defineProperty(exports, "useToolLoader", {
  enumerable: true,
  get: function get() {
    return _hooks["default"];
  }
});
Object.defineProperty(exports, "useToolLoaderBridge", {
  enumerable: true,
  get: function get() {
    return _hooks.useToolLoaderBridge;
  }
});
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _hooks = _interopRequireWildcard(require("./hooks"));
var _excluded = ["tool", "eventHandler", "ScriptComponent", "options", "data"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var toolAllowList = exports.toolAllowList = "amortization,home-affordability,home-equity,mortgage,mortgage-trends,rates,refinance,rent-vs-buy,tool-test,test-tool".split(',');
function ToolLoader(_ref) {
  var _ref$tool = _ref.tool,
    tool = _ref$tool === void 0 ? '' : _ref$tool,
    _ref$eventHandler = _ref.eventHandler,
    eventHandler = _ref$eventHandler === void 0 ? function () {} : _ref$eventHandler,
    _ref$ScriptComponent = _ref.ScriptComponent,
    ScriptComponent = _ref$ScriptComponent === void 0 ? 'script' : _ref$ScriptComponent,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {
      domain: 'https://tools.quickenloans.com'
    } : _ref$options,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useToolLoader = (0, _hooks["default"])(_objectSpread({
      tool: tool,
      ScriptComponent: ScriptComponent,
      eventHandler: eventHandler,
      options: options,
      data: data
    }, props)),
    links = _useToolLoader.links,
    Script = _useToolLoader.script,
    ref = _useToolLoader.ref;
  var ScriptLoader = function ScriptLoader() {
    if (ScriptComponent === 'script') {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    }
    return Script ? Script : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref
  }, links, /*#__PURE__*/_react["default"].createElement(ScriptLoader, null));
}
// export default ToolLoader;